import {EndpointBuilder} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {createApi} from '@reduxjs/toolkit/query/react';
import {baseQueryFn} from './baseQuery';
import {createContentEndpoint} from './endpoints/content.endpoints';
import {createFormEndpoint} from './endpoints/forms.endpoints';
import {createLanguageEndpoint} from './endpoints/language.endpoints';
import {createMediaEndpoint} from './endpoints/media.endpoints';
import {createMembersEndpoint} from './endpoints/members.endpoint';

export type UmbracoContentManagmentEndpointBuilder = EndpointBuilder<
  typeof baseQueryFn,
  never,
  'contentManagmentApi'
>;

// Define a service using a base URL and expected endpoints
export const contentManagmentApi = createApi({
  reducerPath: 'contentManagmentApi',
  baseQuery: baseQueryFn,
  endpoints: builder => ({
    ...createFormEndpoint(builder),
    ...createMembersEndpoint(builder),
    ...createContentEndpoint(builder),
    ...createMediaEndpoint(builder),
    ...createLanguageEndpoint(builder),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFormsQuery,
  useLazyPostFormsQuery,
  useLazyPostMemberQuery,
  useLazyAuthMemberQuery,
  useLazyGetMemberByUsernameQuery,
  useLazyUnPublishedContentQuery,
  useLazyPublishContentQuery,
  useLazyUpdateMemberQuery,
  useLazyDeleteContentQuery,
  useLazyGetContentQuery,
  useGetContentQuery,
  useLazyPostContentQuery,
  useLazyUpdateContentQuery,
  useLazyCreateMediaQuery,
  useLazyGetLanguagesQuery,
  useGetLanguagesQuery,
  useLazyGetMemberExistQuery,
  useLazyCheckMemberEmailExistQuery,
} = contentManagmentApi;
